import { SystemInvariant } from '../SystemInvariant';
import * as Elems from './elements';
import { ModuleError } from '../errors';

export namespace View {
  let rootEl: HTMLElement | null = null;
  let loaderEl: HTMLElement | null = null;
  let timeoutId: number | null = null;
  let redFataErrorEl: HTMLElement | null = null;

  export function init(invariant: SystemInvariant<any, any, any, any>) {
    loaderEl = invariant.elementById('system_loading');
    rootEl = invariant.elementById('system_root');
  }

  export function displayError(
    error: any,
    invariant: SystemInvariant<any, any, any, any>,
    showRedError: boolean = false
  ) {
    showFatalError(error, invariant);
  }

  function showFatalError(error: any, invariant: SystemInvariant<any, any, any, any>) {
    if (redFataErrorEl === null) {
      const errorMessage = [
        `Error on Realytics Portal`,
        '',
        `----------`,
        '',
        error.toString(),
        '',
        '---------- Stack',
        '',
        error.stack ? error.stack : '',
        ...(error instanceof ModuleError
          ? [
              '',
              `Error in module : ${error.getModuleName()}`,
              '',
              error.getModuleError().toString(),
              error.getModuleError() && error.getModuleError().stack ? error.getModuleError().stack : '',
            ]
          : []),
        '',
        ...(error.getHelp ? ['---------- Help', '', error.getHelp(), ''] : []),
        '',
      ].join('\n');
      const subject = `[REALYTICS][ERROR] An error occure on the portal`;
      const mailToLink = `mailto:support@realytics.io?cc=tech@realytics.io&subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(errorMessage)}`;

      redFataErrorEl = Elems.ErrorWrapper(
        ...[
          Elems.Title('Oops !'),
          Elems.SubTitle('Something went wrong !'),
          Elems.Instruction(
            'Please copy the text below and send it to the realytics support team or just ',
            Elems.Link(mailToLink)('Click here to open your mail App'),
            Elems.br(),
            'Then try to ',
            Elems.Button('Reload the page')
          ),
          Elems.ErrorDisplay(errorMessage),
        ].map(elem => {
          elem.style.flexShrink = '0';
          return elem;
        })
      );

      invariant.notNullElement(rootEl).appendChild(redFataErrorEl);
    }
    if (timeoutId !== null) {
      window.clearTimeout(timeoutId);
    }
    window.requestAnimationFrame(() => {
      (redFataErrorEl as any).style.opacity = '1';
      timeoutId = window.setTimeout(() => {
        hideLoader();
      }, 500);
    });
  }

  export function hideLoader() {
    if (timeoutId !== null) {
      window.clearTimeout(timeoutId);
    }
    if (loaderEl) {
      const el = loaderEl;
      el.style.opacity = '0';
      el.style.pointerEvents = 'none';
      timeoutId = window.setTimeout(() => {
        el.style.display = 'none';
      }, 500);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/front-system/engine/view/index.ts